import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_reason_dismissal,
    createReasonDismissal,
    CREATE_REASON_DISMISSAL,
    getAllReasonDismissal,
    updateReasonDismissal,
    UPDATE_REASON_DISMISSAL
} from "../../../redux/reason_dismissal";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ReasonDismissal = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_reason_dismissal = useSelector((state) => state.reason_dismissal_module._get_all_reason_dismissal);
    const _create_reason_dismissal = useSelector((state) => state.reason_dismissal_module._create_reason_dismissal);
    const _update_reason_dismissal = useSelector((state) => state.reason_dismissal_module._update_reason_dismissal);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllReasonDismissal(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_reason_dismissal && _get_all_reason_dismissal.data && _get_all_reason_dismissal.data.datos) {
            setData(_get_all_reason_dismissal.data.datos);
        }
    }, [_get_all_reason_dismissal]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        nombre: "",
        activo: true,
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_reasondismissal').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({...form, nombre: item.nombre, activo: item.activo});
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_reason_dismissal.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_reason_dismissal(CREATE_REASON_DISMISSAL));
            dispatch(getAllReasonDismissal(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_reason_dismissal.status !== 0) {
            dispatch(clear_reason_dismissal(CREATE_REASON_DISMISSAL));
            toast.error(_create_reason_dismissal.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_reason_dismissal, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_reason_dismissal.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_reason_dismissal(UPDATE_REASON_DISMISSAL));
            dispatch(getAllReasonDismissal(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_reason_dismissal.status !== 0) {
            dispatch(clear_reason_dismissal(UPDATE_REASON_DISMISSAL));
            toast.error(_update_reason_dismissal.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_reason_dismissal, dispatch, history, token, id]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el motivo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createReasonDismissal(token, form));
        } else {
            dispatch(updateReasonDismissal(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Motivos de despidos", link: "/motivos-despidos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_reasondismissal').length > 0 ?
                                        <Button type="button" text="Crear" theme="success" onClick={() => {
                                            setModal(true);
                                            setForm({...form, nombre: ''});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Motivo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-header">
                            <h5>Motivo de despido</h5>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <Input
                                    id="nombre"
                                    name="nombre"
                                    label="Motivo"
                                    onChange={handleChange}
                                    value={form.nombre}
                                />
                            </div>
                            <div className="form-group">
                                <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                          state={form.activo}/>
                            </div>
                        </div>
                        <div className="text-center">
                            <button type="button" className="btn btn-outline-dark" onClick={() => {
                                setModal(false);
                                setId(null);
                                setForm({
                                    nombre: "",
                                    id: id,
                                    activo: true
                                })
                            }}> Cancelar
                            </button>
                            <Button type="submit" text="Guardar" theme="success" classes="m-1" disabled={isLoading}/>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default ReasonDismissal;
